import { computed, ref } from 'vue'

export const AUTH_THEME_STORAGE_KEY = 'remoni-auth-theme'

export function resolveAuthTheme(storedValue) {
  return 'light'
  // if (storedValue === 'light' || storedValue === 'dark') {
  //   return storedValue
  // }
  //
  // return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function readStoredAuthTheme() {
  try {
    return localStorage.getItem(AUTH_THEME_STORAGE_KEY)
  } catch {
    return null
  }
}

export function applyAuthTheme(theme) {
  document.documentElement.setAttribute('data-auth-theme', theme)
  document.documentElement.style.colorScheme = theme
  document.body.classList.toggle('auth-login-page--dark', theme === 'dark')
}

export function initAuthTheme() {
  applyAuthTheme(resolveAuthTheme(readStoredAuthTheme()))
}

export function useAuthTheme() {
  const theme = ref(
    document.documentElement.getAttribute('data-auth-theme')
      || resolveAuthTheme(readStoredAuthTheme())
  )

  const isDark = computed(() => theme.value === 'dark')

  const setTheme = (nextTheme) => {
    if (nextTheme !== 'light' && nextTheme !== 'dark') return

    theme.value = nextTheme

    try {
      localStorage.setItem(AUTH_THEME_STORAGE_KEY, nextTheme)
    } catch {
      // ignore storage failures
    }

    applyAuthTheme(nextTheme)
  }

  const toggleTheme = () => {
    setTheme(theme.value === 'dark' ? 'light' : 'dark')
  }

  return {
    theme,
    isDark,
    setTheme,
    toggleTheme,
  }
}
